import { cva } from 'class-variance-authority'

export const OverlayButtonVariant = cva(
  'px-2 text-white outline-1 focus-visible:!outline-1',
  {
    variants: {
      disabled: {
        true: '!text-white opacity-80',
        false: 'hover:bg-primary hover:!text-white hover:opacity-80 '
      }
    }
  }
)
